import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Checkbox, ControlLabel, HelpBlock, Alert } from 'react-bootstrap'
import questionTypes from '../questionTypes.json'

MultipleAnswerQuestion.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  onAnswer: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string,
  help: PropTypes.string
}

function MultipleAnswerQuestion({
  questionId,
  text,
  options,
  onAnswer,
  answers,
  readOnly,
  showValidation,
  validationState = null,
  help
}) {
  const selectedAnswersIds = answers.map(answer => answer.answerId)
  return (<FormGroup validationState={showValidation ? validationState : null}>
    <ControlLabel>{text}</ControlLabel>
    {!readOnly && options.map((option, index) =>
      <Checkbox key={index}
        name={questionId}
        disabled={readOnly}
        onClick={(event) => {
          onAnswer(questionId, questionTypes.multipleAnswer, option.answerId, event.target.value)
        }}
        checked={selectedAnswersIds.indexOf(option.answerId) > - 1}>
        {option.text}
      </Checkbox>)
    }
    {readOnly && options.map((option, index) => {
      if (selectedAnswersIds.indexOf(option.answerId) > - 1) {
        return <Checkbox key={index}
          name={questionId}
          disabled
          checked>
          {option.text}
        </Checkbox>
      }
      return ''
    })}
    {help && showValidation && <HelpBlock>
      <Alert bsStyle='danger'>
        {help}
      </Alert>
    </HelpBlock>}
  </FormGroup>)
}



export default MultipleAnswerQuestion



// WEBPACK FOOTER //
// ./src/components/questions/MultipleAnswerQuestion/MultipleAnswerQuestion.js